module.exports = __webpack_public_path__ + "static/media/cobham_coat_wallet.46a58c50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cobham_coat_wallet.png
// module id = 101
// module chunks = 0